import React from 'react';


const EscCloseBtn = (props) => (
  <button className="moa-ff-sans f7 outline-0 bn pointer pa0" {...props}>
    <div className="br-100 gray o-60 glow fw3 h2 flex items-center pr2">
      <span className="pr1">
        esc
      </span>
      <span>→</span>
    </div>
  </button>
);


export {
  EscCloseBtn,
}



// WEBPACK FOOTER //
// ./src/components/modules/common/EscCloseBtn.js